const BlogDetailsSection2 = () => {
  return (
    <section className="about about--style1 bg-color xts-section py-10 px-6">
      <div className="container max-w-4xl mx-auto py-5">
        <h1 className="text-3xl text-center font-bold pb-4 text-gray-800">
          How Pro Traders Cut Costs and Scale Profits with Smarter Brokerage Plans
        </h1>
        <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
          <div className="col-lg-6">
            <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
              <div className="about__thumb-inner">
                <div className="about__thumb-image floating-content">
                  <img className="dark w-100" src="assets/images/blog/image-2.jpg" alt="about-image" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about__content" data-aos="fade-left" data-aos-duration="800">
              <div className="about__content-inner">
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  In trading, every tick matters — and so does every rupee you save. 
                  At <strong>Asiatic Stock & Securities</strong>, we’ve reimagined brokerage for professionals who demand more from their platform.
                </p>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  Whether you trade manually, through APIs, or via high-frequency algos, our tiered <strong>Pro Plans</strong> 
                  put control back in your hands. Pay per order, go flat monthly, or design a custom high-volume structure — 
                  the choice (and savings) are yours.
                </p>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  With zero hidden charges and institutional-grade infrastructure, your brokerage becomes an advantage, not an expense.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed font-semibold">
                  Trade smarter. Scale faster. Keep more of what you earn.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailsSection2;
